import { render, staticRenderFns } from "./mynotes.vue?vue&type=template&id=20ae02ca&"
import script from "./mynotes.vue?vue&type=script&lang=js&"
export * from "./mynotes.vue?vue&type=script&lang=js&"
import style0 from "./mynotes.vue?vue&type=style&index=0&id=20ae02ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports